import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/home")({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router uses non-Error throw for control flow
    throw redirect({ to: "/create/ugc" })
  },
  component: () => null,
})
